var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 26.8125C24.75 27.9065 24.3154 28.9557 23.5418 29.7293C22.7682 30.5029 21.719 30.9375 20.625 30.9375H6.1875C5.09348 30.9375 4.04427 30.5029 3.27068 29.7293C2.4971 28.9557 2.0625 27.9065 2.0625 26.8125V12.375C2.0625 11.281 2.4971 10.2318 3.27068 9.45818C4.04427 8.6846 5.09348 8.25 6.1875 8.25V10.3125C5.64049 10.3125 5.11589 10.5298 4.72909 10.9166C4.3423 11.3034 4.125 11.828 4.125 12.375V26.8125C4.125 27.3595 4.3423 27.8841 4.72909 28.2709C5.11589 28.6577 5.64049 28.875 6.1875 28.875H20.625C21.172 28.875 21.6966 28.6577 22.0834 28.2709C22.4702 27.8841 22.6875 27.3595 22.6875 26.8125H24.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 4.125C11.828 4.125 11.3034 4.3423 10.9166 4.72909C10.5298 5.11589 10.3125 5.64049 10.3125 6.1875V20.625C10.3125 21.172 10.5298 21.6966 10.9166 22.0834C11.3034 22.4702 11.828 22.6875 12.375 22.6875H26.8125C27.3595 22.6875 27.8841 22.4702 28.2709 22.0834C28.6577 21.6966 28.875 21.172 28.875 20.625V6.1875C28.875 5.64049 28.6577 5.11589 28.2709 4.72909C27.8841 4.3423 27.3595 4.125 26.8125 4.125H12.375ZM12.375 2.0625H26.8125C27.9065 2.0625 28.9557 2.4971 29.7293 3.27068C30.5029 4.04427 30.9375 5.09348 30.9375 6.1875V20.625C30.9375 21.719 30.5029 22.7682 29.7293 23.5418C28.9557 24.3154 27.9065 24.75 26.8125 24.75H12.375C11.281 24.75 10.2318 24.3154 9.45818 23.5418C8.6846 22.7682 8.25 21.719 8.25 20.625V6.1875C8.25 5.09348 8.6846 4.04427 9.45818 3.27068C10.2318 2.4971 11.281 2.0625 12.375 2.0625Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.55847870c8fa49b49c47ea515775acdf.svg";
export { ForwardRef as ReactComponent };